import { lazy, Suspense, useEffect } from "react";
import { Redirect, BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
// import { oktaSignInConfig } from "./config";
// import { LoginCallback } from "@okta/okta-react";
import "react-toastify/dist/ReactToastify.css";

// COMPONENTS
import Layout from "./components/Layout/Layout";
// import Spinner from "./globalComponents/Spinner/Spinner";
import VaultSpinner from "./globalComponents/VaultSpinner/VaultSpinner";

// STYLES
import styles from "./app.module.css";
import PrivateRoute from "./PrivateRoute";
import { useKeycloak } from "@react-keycloak/web";
import { useUserContext } from "./context/allContext";
import { useLocalStorage } from "./hooks/index";

// LAZY LOADED/DYNAMIC IMPORTS (CODE SPLITTING) only loaded in when the Component is requested

const Login = lazy(() => import("./pages/Login/Login"));
const Home = lazy(() => import("./pages/Home/Home"));
const Autopay = lazy(
  () => import("./pages/Autopay/AutoPay"),
);
const Enrollment = lazy(
  () => import("./pages/Autopay/Enrollment"),
);
// const NoAuthHome = lazy(() => import("./pages/NoAuthHome/NoAuthHome"));
const QuickPay = lazy(() => import("./pages/QuickPay/QuickPay"));


function App() {
  const { keycloak } = useKeycloak();
  // @ts-ignore
  const { setUser, logMeOut } = useUserContext();
  // eslint-disable-next-line
  const [_, setLocalToken] = useLocalStorage("vault_token", null);
  const [_rt, setLocalRefreshToken] = useLocalStorage("rt", null);

  let keycloakSession = {
    authenticated: false
  };
  if (keycloak.authenticated) {
    // @ts-ignore
    sessionStorage.setItem("keycloakSession", JSON.stringify(keycloak));
  }

  useEffect(() => {
    if (keycloak?.authenticated) {
      if (!keycloak.token) {
        logMeOut();
      }
      const userNToken = {
        token: keycloak?.token,
        user: keycloak?.tokenParsed,
      };
      setUser(userNToken);
      // TODO: fix vault_token being stored as ""<token>""
      // @ts-ignore
      setLocalToken(keycloak?.token);
      // @ts-ignore
      setLocalRefreshToken(keycloak?.refreshToken)

    } else {
      //@ts-ignore
      keycloakSession = JSON.parse(sessionStorage.getItem("keycloakSession"));
      const userNToken = {
        //@ts-ignore
        token: keycloakSession?.token,
        //@ts-ignore
        user: keycloakSession?.tokenParsed,
      };
      setUser(userNToken);
    }
  }, [keycloak?.authenticated]);

  return (
    <div className={styles.appContainer}>
      {process.env.REACT_APP_AUTH_FLAG === "true" ? (

        <Router>
          <Switch>
            <Suspense
              fallback={
                <div className={styles.spinnerWrapper}>
                  <VaultSpinner />
                </div>
              }
            >
              <Route exact path="/">
                <Redirect to={{ pathname: "/quickpay" }} />
              </Route>
              <Route exact path="/login" component={Login} />
              <Route exact path="/quickpay" component={QuickPay} />
              {/*<SecureRoute exact path="/about" component={About} />*/}
              {/*<Route exact path="/quickpay" component={QuickPay} />*/}

              <PrivateRoute>
                <Route exact path="/home" component={Home} />
                <Route exact path="/autopay" component={Autopay} />
                <Route exact path="/enrollment" component={Enrollment} />               
                {/* <Route path="/login" render={() => <Login config={oktaSignInConfig} />} />
                <Route path="/login/callback" component={LoginCallback} /> */}
              </PrivateRoute>
              <ToastContainer />
            </Suspense>
          </Switch>
        </Router>

      ) : (
        <Router>

          <Switch>
            <Suspense
              fallback={
                <div className={styles.spinnerWrapper}>
                  <VaultSpinner />
                </div>
              }
            >
              {/* <Route exact path="/" component={NoAuthHome} /> */}
              <ToastContainer />
            </Suspense>
          </Switch>

        </Router>
      )}
    </div>
  );
}

export default App;